import React, { useEffect, useState } from 'react';
import { $document } from '@umu/umu-dom';
import { fetchData } from '@umu/umu-fetch';
import { API } from '../../api';
import { ListLoading } from 'common/src/components';
import InfiniteScroll from '../../../@infiniteScroll/infiniteScroll';

import './index.scss';
import { lang } from '@umu/ukit-lang';
export enum MEMBER_TYPE {
    USER = 'user',
    GROUP = 'group',
    CLASS = 'class',
    DEPARTMENT = 'department',
}
export interface IAccountList {
    page_info: IAccountPageInfo;
    list: ISearchMemberInfo[];
}
export interface ISearchMemberInfo {
    account: string;
    account_type: MEMBER_TYPE;
    avatar: string;
    email: string;
    department_id?: string;
    department_name?: string;
    class_name?: string;
    group_name?: string;
    id: string;
    user_num?: number;
    is_exist: number;
    login_name: string;
    phone: string;
    student_id: string;
    umu_id: string;
    user_name: string;
}

export interface IAccountPageInfo {
    current_page: number;
    list_class_num: number;
    list_department_num: number;
    list_group_num: number;
    list_total_num: number;
    list_user_num: number;
    size: number;
    total_page_num: number;
}
interface IPermissionProps {
    data: {
        [key: string]: any;
    };
    portId: string;
}
export const defaultAccount = {
    list: [],
    page_info: {
        current_page: 1,
        list_class_num: 0,
        list_department_num: 0,
        list_group_num: 0,
        list_total_num: 0,
        list_user_num: 0,
        size: 5,
        total_page_num: 0,
    },
};
export const defaultListRes = {
    list: [],
    page_info: {
        current_page: 1,
        list_total_num: 0,
        total_num: 0,
        size: 20,
        total_page_num: 0,
    },
    is_need_tip_first: false,
};
interface IAccountListParams {
    obj_id: string;
    obj_type: string;
    is_with_full_department: number;
    page: number;
    size: number;
}
export const getAccountList = (params: IAccountListParams) => {
    return fetchData(API.GET_ACCOUNT_LIST, params, { silent: true }).then(
        (res: IResponse<IAccountList>) => {
            return res.data ? res.data : defaultListRes;
        },
        () => {
            return defaultListRes;
        },
    );
};

export const PermissionList = (props: IPermissionProps) => {
    const [viewport, setViewport] = useState<Element | undefined>(undefined);
    const [scroller, setscroller] = useState<Element | undefined>(undefined);
    const [accountInfo, setAccountInfo] = useState<IAccountList>(defaultAccount);
    const [isLoading, setIsLoad] = useState(true);
    useEffect(() => {
        const viewportEl = $document.getElementById(props.portId) || undefined;
        const scrollerEl = $document.getElementById(props.portId) || undefined;
        setViewport(viewportEl);
        setscroller(scrollerEl);
        getList(1);
    }, [props.data, props.portId]);

    const getList = async (page: number) => {
        const res: IAccountList = await getAccountList({
            obj_id: props.data.id,
            obj_type: 'micro_page',
            is_with_full_department: 1,
            page,
            size: 20,
        });
        res.list = accountInfo.list.concat(res.list || []);
        setAccountInfo(res);
        setIsLoad(false);
    };
    const getLoadMore = () => {
        const { page_info } = accountInfo;
        if (isLoading) {
            return;
        }
        setIsLoad(true);
        if (page_info.current_page < page_info.total_page_num) {
            getList(page_info.current_page + 1);
        }
    };
    const renderList = () => {
        return !!accountInfo.list.length ? (
            accountInfo.list.map((_) => {
                return <li key={`permission-item-${_.id}`}>{_.account}</li>;
            })
        ) : isLoading ? (
            <ListLoading />
        ) : (
            <li>{lang('暂无指定账号')}</li>
        );
    };
    return (
        <InfiniteScroll
            load={getLoadMore}
            hasMore={
                !!accountInfo.page_info &&
                !!accountInfo.page_info.total_page_num &&
                accountInfo.page_info.total_page_num > accountInfo.page_info.current_page
            }
            viewportSelector={viewport}
            scrollerSelector={scroller}
            isLoading={isLoading}
            bottomDistance={70}
            scrollThreshold={500}
        >
            <ul className="permission-list">{renderList()}</ul>
        </InfiniteScroll>
    );
};
